<template>
    <d-container fluid class="main-content-container px-4">
        <!-- Page Header -->
        <d-row no-gutters class="page-header py-4">
            <d-col class="text-center text-sm-left flex-header mb-sm-0">
                <h3 class="page-title">Edytuj wydatek</h3>
                <d-button theme="secondary" @click.prevent="$router.push({name: 'expenses-list'})"><i class="material-icons">keyboard_backspace</i> Wróć do listy</d-button>
                <d-button :class="{isLoading : submitting}" theme="success" @click.prevent="submitForm"><i class="material-icons">save</i> Zapisz wydatek</d-button>
            </d-col>
        </d-row>

        <div v-if="!fetched">
            <h2 class="preloader isLoading">Trwa ładowanie</h2>
        </div>
        <transition name="fade" v-else>
            <d-card class="card-small" v-if="fetched">
                <d-card-header>
                    <h6 class="m-0">Szczegóły wydatku</h6>
                </d-card-header>
                <d-list-group flush>
                    <d-list-group-item class="p-3">
                        <d-form>
                            <d-form-row>
                                <d-col md="6" class="form-group">
                                    <label>Użytkownik</label>
                                    <d-input readonly :value="expense.user.name + ' ' + expense.user.surname"></d-input>
                                </d-col>
                            </d-form-row>
                            <d-form-row>
                                <d-col md="6" class="form-group">
                                    <label>Suma</label>
                                    <ss-price-input type="text"
                                                    name="amount"
                                                    v-model="expense.amount"
                                                    @input="lar_errors.clear('amount')"
                                                    :class="{'is-invalid' : lar_errors.has('amount')}"
                                                    placeholder=""/>
                                    <div class="invalid-feedback" v-text="lar_errors.get('amount')"></div>
                                </d-col>
                                <d-col md="6" class="form-group">
                                    <label>Sposób płatności</label>
                                    <d-select size="sm" v-model="expense.payment_type"
                                              @input="lar_errors.clear('payment_type')"
                                              :class="{'is-invalid' : lar_errors.has('payment_type') }">
                                        <option value="cash">Gotówka</option>
                                        <option value="transfer">Przelew</option>
                                    </d-select>
                                    <div class="invalid-feedback" v-text="lar_errors.get('payment_type')"></div>
                                    <d-checkbox
                                            class="mt-2 yes-no"
                                            v-if="expense.payment_type === 'transfer'"
                                            :value="'1'"
                                            :unchecked-value="'0'"
                                            toggle
                                            v-model="expense.transfer_complete">
                                        Zrealizowany
                                    </d-checkbox>
                                    <d-checkbox
                                            class="mt-2 yes-no"
                                            v-if="expense.payment_type === 'cash'"
                                            :value="'1'"
                                            :unchecked-value="'0'"
                                            toggle
                                            v-model="expense.cash_refunded">
                                        Wykonano zwrot
                                    </d-checkbox>
                                </d-col>
                            </d-form-row>
                            <d-form-row  v-if="expense.payment_type === 'transfer'">
                                <d-col md="6" class="form-group">
                                    <ss-input v-model="expense.transfer_title" name="transfer_title" label="Tytuł przelewu" placeholder="Tytuł przelewu"></ss-input>
                                </d-col>
                                <d-col md="6" class="form-group">
                                    <ss-input v-model="expense.account_number" name="account_number" label="Numer konta" placeholder="Numer konta bankowego"></ss-input>
                                </d-col>
                            </d-form-row>
                            <d-form-row>
                                <d-col md="6" class="form-group">
                                    <label>Typ kosztu</label>
                                    <d-input readonly :value="expense.expenses_cost_type_name"></d-input>
                                </d-col>
                                <d-col md="6" class="form-group" v-if="expense.expenses_cost_type === 1">
                                    <label>Komornik</label>
                                    <d-input v-if="expense.bailiff" readonly :value="expense.bailiff.name"></d-input>
                                    <d-input v-else readonly value="Komornik usunięty"></d-input>
                                </d-col>
                                <d-col md="6" class="form-group" v-if="expense.expenses_cost_type === 2">
                                    <label>Nazwa sądu</label>
                                    <d-input readonly :value="expense.court.name"></d-input>
                                </d-col>
                                <d-col md="6" class="form-group" v-if="expense.expenses_cost_type === 3">
                                    <ss-input v-model="expense.recipent" name="recipent" label="Odbiorca" placeholder="Odbiorca"></ss-input>
                                </d-col>
                            </d-form-row>
                            <d-form-row v-if="expense.schedule_id !== 0">
                                <d-col md="6" class="form-group">
                                    <label>Połączone z umową</label>
                                    <d-input readonly :value="expense.schedule ? expense.schedule.contract_number : 'Umowa została usunięta'"></d-input>
                                </d-col>
                                <d-col md="6" class="form-group" v-if="expense.contract_case_id">
                                    <label>Połączone ze sprawą egzekucyjną</label>
                                    <d-input readonly :value="expense.contract_case ? expense.contract_case.number : 'Sprawa została usunięta'"></d-input>
                                </d-col>
                            </d-form-row>
                            <div class="form-group">
                                <ss-textarea v-model="expense.comment"
                                             name="comment"
                                             label="Komentarz"
                                             placeholder="Komentarz"></ss-textarea>
                            </div>
                        </d-form>
                    </d-list-group-item>
                </d-list-group>
            </d-card>
        </transition>
    </d-container>
</template>

<script>
  import LarErrors from '../helpers/Errors';
  import expenseUtil from '../utils/expense'
  import SsPriceInput from '../components/common/SsPriceInput'
  import SsAutocomplete from '../components/common/SsAutocomplete'
  import SchedulesAutocomplete from '../components/common/SsSchedulesAutocomplete';
  import { mapGetters, mapActions } from 'vuex'

  export default {
    name: "expenseEdit",
    components: {
      LarErrors,
      SsPriceInput,
      SsAutocomplete,
      SchedulesAutocomplete
    },
    data(){
      return{
        fetched: false,
        lar_errors: LarErrors,
        submitting: false,
        cost_types: [],
        expense: _.clone(expenseUtil),
        executions: []
      }
    },
    computed: {
      ...mapGetters([
        'allUsers',
        'allCostTypes',
        'allCourts',
        'allBailiffs'
      ]),
    },
    methods: {
      ...mapActions([
        'getAllUsers',
        'getAllCostTypes',
        'getAllCourts',
        'getAllBailiffs'
      ]),
      fetchData() {
        axios.post('api/expenses/item/' + this.$route.params.id).then(response => {
          this.expense = response.data.data;
          this.fetched = true;
        }).catch((errors) =>{
          this.fetched = true;
          console.log(errors);
        })
      },
      submitForm(){
        this.submitting = true;
        axios.post('api/expenses/update/' + this.$route.params.id, this.expense).then(response => {
          Vue.swal({
            type: 'success',
            title: 'Wydatek został zapisany.',
            showConfirmButton: true,
          }).then(() => {
            this.fetchData()
          });
          this.submitting = false;
        }).catch((error) =>{
            Vue.swal({
                type: 'error',
                title: error.response.data.message,
                html: Vue.transformErrorsToHtml(error.response.data.errors),
                showConfirmButton: true,
            });
            this.submitting = false;
            LarErrors.record(error.response.data.errors)
        })
      },
      userSelectedHanlder(id) {
        this.expense.user_id = id
      },
      scheduleSelected(a, b){
        a.schedule_id = b.id;
        axios.post('api/contracts-case/get-cases/' + b.id).then(response => {
          this.executions = response.data;
        }).catch((errors) =>{
          console.log(errors);
        })
      }
    },
    mounted(){
      this.getAllCostTypes();
      this.getAllUsers();
      this.getAllCourts();
      this.getAllBailiffs();
      this.fetchData()
    }
  }
</script>
